import React, { useEffect, useState } from "react";
import API from "../../services";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { S3_IMG } from "../../constants/common";
import "./CasinoIframe.scss";
import { RootState } from "../../models/RootState";
import { connect } from "react-redux";
import { setCasinoData } from "../../store/authReducer";
import { FavoriteBorderOutlined, FavoriteOutlined } from "@mui/icons-material";
// import Loader from "../../assets/images/Strike_White_Logo_Transparent_GIF.gif";
import { Dialog } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { toast } from "react-toastify";
import filter from '../../assets/images/filter.svg';
import search from '../../assets/images/search.svg';
import Delete from '../../assets/images/delete.svg'; 
import boxes from '../../assets/images/view-all-svgrepo-com 1.svg';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useRef, useCallback } from "react";
import JumpToTop from '../../assets/images/jump-to-top.svg'
import list from '../../assets/images/nine-small-boxes-svgrepo-com.svg'
import grid from '../../assets/images/list-svgrepo-com.svg'
import { Loader } from "../../constants/whitelabelEnv";
import { domain } from "../../constants/Branding";

interface CasinoPageProps {
  casinoData: any;
  setCasinoData: (data: any) => void;
  activeWallet: any;
}

const CasinoIframe: React.FC<CasinoPageProps> = ({
  casinoData,
  setCasinoData,
  activeWallet
}) => {
  const location = useLocation();
  const [loading, setLoading] = useState<boolean>(false);
  const [gameSrc, setGameSrc] = useState<string | null>(null);
  const [gameData, setGameData] = useState<any>();
  const [providersList, setProvidersList] = useState<any>();
  const navigate = useNavigate();

  const [showPopup, setShowPopup] = useState(false);
  const [pendingGameLink, setPendingGameLink] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [categories, setCategories] = useState<{ key: string; label: string; icon: string }[]>([]);
  const [showProviderModal, setShowProviderModal] = useState(false);
  const [selectedProviders, setSelectedProviders] = useState<string[]>([]);
  const [providerSearch, setProviderSearch] = useState("");
  const [tempSelectedProviders, setTempSelectedProviders] = useState<string[]>([]);
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [providerGamesList, setProviderGamesList] = useState<any[]>([]);
  const [categoryGamesList, setCategoryGamesList] = useState<any[]>([]);
  const [filteredProviderItems, setFilteredProviderItems] = useState<any[]>([]);
  const [allProviders, setAllProviders] = useState<any[]>([]);
  const [gamesLoading, setGamesLoading] = useState(false);
  const [allGamesPage, setAllGamesPage] = useState(1);
  const [hasMorePages, setHasMorePages] = useState(true);
  const loaderRef = useRef<HTMLDivElement | null>(null);
  const [loadMoreLoading, setLoadMoreLoading] = useState(false);
  const [firstLoadComplete, setFirstLoadComplete] = useState(false);
  const [providerPayload, setProviderPayload] = useState<any | null>(null);
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [lastSearchedText, setLastSearchedText] = useState("");
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [isListView, setIsListView] = useState(false);
  const [noSearchResults, setNoSearchResults] = useState(false);


  const dataSeparation = (data: any) => {
    const providersSection = data.find(
      (section: any) =>
        section?.sectionTitle?.toLocaleLowerCase() === "providers"
    );

    const filteredSections = data.filter(
      (section: any) =>
        section?.sectionTitle?.toLocaleLowerCase() !== "providers"
    );

    setGameData(filteredSections);
    setProvidersList(providersSection);
  };

  const handleProvClick = (prov: any) => {
    navigate("/providergames", { state: { prov } });
  };

  useEffect(() => {
    if (casinoData && casinoData.length > 0) {
      dataSeparation(casinoData);
    } else {
      // getCasinoInfo();
    }
    getCategories();
    fetchProviders();
    sessionStorage.setItem("previousPath", location.pathname);
  }, []);

  const handleFavoriteClick = async (game: any) => {
    setCategoryGamesList((prev: any[]) =>
      prev?.map((g) => (g?.id === game?.id ? { ...g, isFavorite: !g?.isFavorite } : g))
    );
    setSearchResults((prev: any[]) =>
      prev?.map((g) => (g?.id === game?.id ? { ...g, isFavorite: !g?.isFavorite } : g))
    );

    let response;
    try {
      response = await API.post("/webapp/set-favorite", {
        category: game.category,
        id: game.id,
        isFavorite: !game.isFavorite,
        name: game?.name,
        provider: game?.provider,
        subProvider: game?.subProvider,
        thumbnail: game?.thumbnail,
        type: game?.type,
        tgProviderId: game?.tgProviderId,
        tableId: game?.tableId,
        userKey: sessionStorage.getItem("userKey"),
      });
    } catch (error) {
      console.error("Error updating favorite status:", error);
      // Revert on error
      setCategoryGamesList((prev: any[]) =>
        prev?.map((g) => (g?.id === game?.id ? { ...g, isFavorite: !g?.isFavorite } : g))
      );
      setSearchResults((prev: any[]) =>
        prev?.map((g) => (g?.id === game?.id ? { ...g, isFavorite: !g?.isFavorite } : g))
      );
      return;
    }

    if (response?.data?.status !== "RS_OK") {
      // Revert on non-OK
      setCategoryGamesList((prev: any[]) =>
        prev?.map((g) => (g?.id === game?.id ? { ...g, isFavorite: !g?.isFavorite } : g))
      );
      setSearchResults((prev: any[]) =>
        prev?.map((g) => (g?.id === game?.id ? { ...g, isFavorite: !g?.isFavorite } : g))
      );
    }
  };

  const gotoSeeAll = (section: any) => {
    navigate("/see-all", { state: { tag: section.sectionTag, title: section.sectionTitle } });
  }

  const handlePlayClick = (game: any, section: any) => {
    const encodedLink = `/play/${btoa(`${game?.id}::${game?.tgProviderId}:${game?.provider}:${game?.subProvider}:${game?.type}:${game?.category}:${game?.tableId ? game?.tableId : ""}:${game?.isLock}:${section?.isLock}`)}`;

    if (activeWallet === "PLAY_CHIPS" && game?.isPlayChipDisabled) {
      setPendingGameLink(encodedLink);
      setShowPopup(true);
    } else {
      navigate(encodedLink);
    }
  };

  const getCategories = async () => {
    try {
      const response = await API.post("/webapp/get-categories", {});
      if (
        response.data?.status === "RS_OK" &&
        Array.isArray(response.data?.categories)
      ) {
        const formatted = response.data.categories.map((cat: any) => ({
          key: cat.category,
          label: cat.category,
          icon: cat.categoryIcon
        }));

        const finalCategories = [
          { key: "all", label: "All Games", icon: "src/assets/images/view-boxes-svgrepo-com.svg" },
          ...formatted
        ];
        setCategories(finalCategories);
        if (finalCategories.length > 1) {
          handleCategoryClick(finalCategories[0]);
        }
      } else {
        toast.error("Failed to fetch categories");
      }
    } catch (err) {
      console.error("Error fetching categories:", err);
    }
  };

  const fetchGamesByCategories = async (payload: any, reset: boolean = true) => {

    try {
      const response = await API.post("/webapp/get-games-by-categories", payload);

      if (response.data?.status === "RS_OK") {
        const games = response.data.games || [];
        const providers = Array.isArray(response.data.providers) ? response.data.providers : [];

        if (reset) {
          setCategoryGamesList(games);
        } else {
          setCategoryGamesList((prev) => [...prev, ...games]);
        }

        setFilteredProviderItems(providers);
        return games.length;
      } else {
        console.warn(response.data?.errorDescription);
        if (reset) setCategoryGamesList([]);
      }
    } catch (error) {
      console.error("fetchGamesByCategories error", error);
      if (reset) setCategoryGamesList([]);
    }
    return 0;
  };



  const handleApplyProviderFilters = async () => {
    setShowProviderModal(false);
    setSelectedProviders(tempSelectedProviders);

    if (tempSelectedProviders.length > 0) {
      setProviderPayload(null); // stop infinite scroll payload for filtered mode
    }

    if (tempSelectedProviders.length === 0) {
      setProviderGamesList([]);
      setCategoryGamesList([]);
      setSelectedCategory("all");
      dataSeparation(casinoData);
      return;
    }

    const selectedProvObjs = (selectedCategory === "all" ? allProviders : filteredProviderItems)?.filter(
      (prov: any) => tempSelectedProviders.includes(prov.name)
    );

    if (!selectedProvObjs || selectedProvObjs.length === 0) {
      setProviderGamesList([]);
      return;
    }

    setGamesLoading(true);

    try {
      const payload: any = {
        providers: selectedProvObjs.map((prov: any) => ({
          tgProviderId: prov.tgProviderId,
          providerName: prov.provider,
          subProviderName: prov.subProvider,
        })),
      };

      if (selectedCategory !== "all") {
        const cat = categories.find(c => c.key === selectedCategory);
        if (cat) payload.category = cat.label;
      } else if (tempSelectedProviders.length === 0) {
        payload.pageNo = 1;
        payload.pageSize = 50;
        setProviderPayload(payload);
      }

      await fetchGamesByCategories(payload);
      setProviderGamesList([]);
    } catch (err) {
      console.error("Error loading games for selected providers:", err);
    } finally {
      setGamesLoading(false);
    }
  };

  const handleCategoryClick = async (category: { key: string; label: string }) => {
    // Prevent category API call if search is active
    if (searchText.length > 4) return;
    setShowSearchInput(false);
    setSearchText(""); 
    setSearchResults([]);
    setLastSearchedText("");   

    setSelectedCategory(category.key);
    setCategoryGamesList([]);
    setAllGamesPage(1);
    setSelectedProviders([]);
    setTempSelectedProviders([]);
    setFilteredProviderItems([]);
    setGamesLoading(true);
    setHasMorePages(true);
    setFirstLoadComplete(false); 
    setProviderSearch("");

    try {
      const payload: any = {};

      if (category.key !== "all" && category.label) {
        payload.category = category.label;
      } else if (selectedProviders.length === 0) {
        payload.pageNo = 1;
        payload.pageSize = 50;
      }

      await fetchGamesByCategories(payload);

      if (category.key === "all") {
        setFirstLoadComplete(true);
      }
    } catch (error) {
      console.error("Failed to get games", error);
    } finally {
      setGamesLoading(false);
    }
  };


  const loadMoreAllGames = async () => {
    if (
      loadMoreLoading ||
      !hasMorePages ||
      selectedCategory !== "all" ||
      allGamesPage === 0 ||
      selectedProviders.length > 0 ||
      showingSearch // <- block while any search is active (API or local)
    ) {
      console.log("[LOAD MORE] blocked", {
        loadMoreLoading, hasMorePages, selectedCategory, allGamesPage,
        selectedProvidersLen: selectedProviders.length, showingSearch
      });
      return;
    }

    setLoadMoreLoading(true);
    const nextPage = allGamesPage + 1;
    try {
      let requestPayload: any = { pageNo: nextPage, pageSize: 50 };
      if (providerPayload) requestPayload = { ...providerPayload, pageNo: nextPage };

      console.log("[LOAD MORE] calling /get-games-by-categories", requestPayload);
      const newCount = await fetchGamesByCategories(requestPayload, false);
      setAllGamesPage(nextPage);
      if (newCount < 50) setHasMorePages(false);
    } catch (err) {
      console.error("[LOAD MORE] error", err);
    } finally {
      setLoadMoreLoading(false);
    }
  };



  const fetchProviders = async () => {
    try {
      const response = await API.post(`/webapp/get-providers`, {});
      if (response.data?.status === "RS_OK" && Array.isArray(response.data.providers)) {
        setAllProviders(response.data.providers);
      } else {
        toast.error("Failed to fetch providers");
      }
    } catch (error) {
      console.error("Error fetching providers:", error);
    }
  };

  const filteredProviders = (
    selectedCategory === "all" ? allProviders : filteredProviderItems
  )?.filter((provider: any) =>
    provider?.subProvider?.toLowerCase().includes(providerSearch.toLowerCase())
  );

  const performGameSearch = async (text: string) => {
    try {
      const response = await API.post("/webapp/game-search", { gameName: text });
      if (response.data?.status === "RS_OK") {
        const games = response.data.games || [];
        setSearchResults(games);
        setNoSearchResults(games.length === 0);
      } else {
        setSearchResults([]);
        setNoSearchResults(true);
      }
    } catch (err) {
      console.error("Game search failed", err);
      setSearchResults([]);
      setNoSearchResults(true);
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      const trimmedText = searchText.trim().toLowerCase();
      const isAllCategory = selectedCategory === "all";
      const noProvidersSelected = selectedProviders.length === 0;

      if (trimmedText.length === 0) {
        setSearchResults([]);
        setLastSearchedText("");
        setNoSearchResults(false);
        return;
      }

      if (isAllCategory && noProvidersSelected) {
        if (trimmedText.length >= 4 && trimmedText !== lastSearchedText) {
          performGameSearch(trimmedText);
          setLastSearchedText(trimmedText);
        } else if (trimmedText.length < 4) {
          setSearchResults([]);
          setNoSearchResults(false);
        }
      } else {
        const filtered = categoryGamesList.filter((game) =>
          game?.name?.toLowerCase().includes(trimmedText)
        );
        setSearchResults(filtered);
        setNoSearchResults(trimmedText.length > 0 && filtered.length === 0);
      }
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [searchText, selectedCategory, selectedProviders, categoryGamesList, lastSearchedText]);


  const isAllCategory = selectedCategory === "all";
  const noProvidersSelected = selectedProviders.length === 0;
  const showingSearch =
    (isAllCategory && noProvidersSelected && searchText.trim().length >= 4) ||
    ((!isAllCategory || !noProvidersSelected) && searchText.trim().length > 0);

  const showNoGames =
    !gamesLoading && showingSearch && noSearchResults;

  const gamesToShow = showingSearch ? searchResults : categoryGamesList;

  useEffect(() => {
    if (!firstLoadComplete || selectedCategory !== "all" || selectedProviders.length > 0) return;
    if (showingSearch) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !loadMoreLoading && hasMorePages) {
          loadMoreAllGames();
        }
      },
      { threshold: 1, rootMargin: "0px 0px 200px 0px" }
    );

    const currentLoader = loaderRef.current;
    if (currentLoader) observer.observe(currentLoader);

    return () => {
      if (currentLoader) observer.unobserve(currentLoader);
    };
  }, [
    firstLoadComplete,
    loadMoreLoading,
    hasMorePages,
    selectedCategory,
    selectedProviders.length,
    showingSearch,
  ]);



  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <>
      <div className="flex flex-col px-3 mt-2 w-full pb-[6rem] pt-4 casino">
        {
          loading ? (
            <div className="home-loading">
              <img src={Loader(domain)} style={{ height: '10rem' }} />
            </div>
          ) : (
            <>
              <div className="main-section">
              </div>
              <div className="sticky-controls-wrapper bg-[#040d1a] z-10 sticky top-[4rem] pt-4 pb-2">
                {/* CATEGORY BAR */}
                <div className="category-bar flex items-center gap-2">
                  {/* Static "All Games" */}
                  {categories.length > 0 && (
                    <div
                      className={`category-tab w-[78px] h-[50px] px-1 py-1 text-center rounded-lg text-[10px] font-medium cursor-pointer border transition-all duration-300
                          ${selectedCategory === categories[0].key
                            ? "bg-border-color text-white border-pink-300 shadow-md"
                            : "bg-[#101822] text-zinc-400 border border-zinc-700"
                          }`}
                      onClick={() => handleCategoryClick(categories[0])}
                    >
                      <div className="flex flex-col items-center justify-center h-full w-full">
                        <img
                          loading="lazy"
                          src={boxes}
                          className={`w-4 h-4 mb-1 custom-icon-filter ${
                            selectedCategory === categories[0].key
                              ? "category-icon-unselected"
                              : "category-icon-selected"
                          }`}
                          alt={categories[0].label}
                          onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.onerror = null;
                            target.src = `${S3_IMG}/casino.svg`;
                          }}
                        />
                        <div className={`flex items-center justify-center text-center break-words text-[8px] w-[68px] h-[1.5rem] overflow-hidden leading-tight custom-icon-filter ${
                            selectedCategory === categories[0].key
                              ? "category-icon-selected"
                              : "category-icon-unselected"
                          }`}
                        >
                          {categories[0].label}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Scrollable categories */}
                  <div className="flex gap-2 ml-2 overflow-x-auto" style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}>
                    {categories.slice(1).map((category) => (
                      <div
                        key={category.key}
                        className={`category-tab w-[78px] h-[50px] px-1 py-1 text-center rounded-lg text-[10px] font-medium cursor-pointer border transition-all duration-300
                            ${selectedCategory === category.key
                              ? "bg-border-color text-white border-pink-300 shadow-md"
                              : "bg-[#101822] text-zinc-400 border border-zinc-700"
                            }`}
                        onClick={() => handleCategoryClick(category)}
                      >
                      <div className="flex flex-col items-center justify-center h-full w-full">
                        <img
                          loading="lazy"
                          src={category.icon}
                          className={`w-4 h-4 mb-1 custom-icon-filter ${selectedCategory === category.key? "category-icon-unselected": "category-icon-selected"}`}
                          alt={category.label}
                          onError={(e) => {
                            const target = e.target as HTMLImageElement;
                            target.onerror = null;
                            target.src = `${S3_IMG}/casino.svg`;
                          }}
                        />
                        <div
                          className={`flex items-center justify-center text-center break-words text-[8px] w-[68px] h-[1.5rem] overflow-hidden leading-tight custom-icon-filter ${
                            selectedCategory === category.key
                              ? "category-icon-selected"
                              : "category-icon-unselected"
                          } capitalize`}
                        >
                          {category.label}
                        </div>
                      </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* PROVIDER FILTER + SEARCH */}
                <div className="flex items-center justify-between mt-4">
                  <div className="flex items-center gap-2">
                    {!showSearchInput && (
                      <button
                        onClick={() => {
                          setTempSelectedProviders(selectedProviders);
                          setShowProviderModal(true);
                        }}
                        className="flex items-center px-2 py-1 rounded bg-inputbox-color border border-border-color text-white text-xs"
                      >
                        <img src={filter} alt="Filter" className="w-3 h-3 mr-1" />
                        {selectedProviders.length > 0
                          ? `Providers (${selectedProviders.length})`
                          : "Select provider"}
                      </button>
                    )}

                    {selectedProviders.length > 0 && !showSearchInput && (
                      <button
                        className="flex items-center justify-center w-5 h-5 rounded bg-inputbox-color border border-border-color"
                        onClick={() => {
                          setSelectedProviders([]);
                          setTempSelectedProviders([]);
                          setProviderGamesList([]);
                          setCategoryGamesList([]);
                          setProviderPayload(null);
                          const currentCategory = categories.find(c => c.key === selectedCategory);
                          if (currentCategory) {
                            handleCategoryClick(currentCategory);
                          }
                        }}
                      >
                        <img src={Delete} alt="Delete" className="w-3 h-3" />
                      </button>
                    )}
                  </div>

                  {showSearchInput ? (
                    <div className="flex items-center w-full relative">
                     <input
                        type="text"
                        placeholder="Game Search"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        className="w-[100%] h-7 px-3 py-1 text-xs rounded bg-inputbox-color text-white border border-border-color"
                        style={{ minWidth: "auto" }}
                      />
                      <button
                        onClick={() => {
                          setShowSearchInput(false);
                          setSearchText("");
                        }}
                        className="absolute right-3 text-white"
                      >
                        <CloseIcon fontSize="inherit" />
                      </button>
                    </div>
                  ) : (
                    <button
                      onClick={() => {
                        setShowSearchInput(true);
                      }}
                      className="ml-2 flex items-center justify-center w-7 h-7 rounded bg-inputbox-color border border-border-color"
                    >
                      <img src={search} alt="Search" className="w-3 h-3" />
                    </button>
                  )}
                </div>
              </div>
              <div className="games-grid mt-6 grid grid-cols-3 gap-3">
                {gamesLoading ? (
                  <div className="col-span-full flex justify-center items-center min-h-[60vh]">
                    <img src={Loader(domain)} style={{ height: "5rem" }} alt="Loading..." />
                  </div>
                ) : showNoGames ? (
                  <div className="col-span-full flex justify-center items-center min-h-[40vh]">
                    <p className="text-zinc-400 text-sm">No Games Found</p>
                  </div>
                ) : (
                  gamesToShow
                    .filter((game: any) => !game?.subProvider?.startsWith('Yuvi Games'))
                    .map((game: any, index: number) => (
                    <div
                      key={game.id + index}
                      className="game-card cursor-pointer"
                      onClick={() => handlePlayClick(game, {})}
                    >
                      <div className="game-tile relative overflow-hidden rounded-lg">
                        <img
                          loading="lazy"
                          src={game.thumbnail}
                          style={{ objectFit: "unset" }}
                          alt={game.name}
                          onError={(e) => {
                            const t = e.target as HTMLImageElement;
                            t.onerror = null;
                            t.src = "https://cdn.stwin2025.co/TG/BotYaPot/Category/stikelogo1.svg";
                          }}
                          className={`w-full h-full rounded-lg object-cover relative mb-2 ${
                            activeWallet === "PLAY_CHIPS" && game?.isPlayChipDisabled ? "greyed-out" : ""
                          }`}
                        />
                        <div className="absolute top-[5px] right-[5px]">
                          {game?.isFavorite ? (
                            <FavoriteOutlined
                              className="gold-favourite-img"
                              titleAccess="remove from favourites"
                              onClick={(e) => { e.stopPropagation(); handleFavoriteClick(game); }}
                            />
                          ) : (
                            <FavoriteBorderOutlined
                              className="red-favourite-img"
                              style={{ fill: "white" }}
                              titleAccess="add to favourites"
                              onClick={(e) => { e.stopPropagation(); handleFavoriteClick(game); }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
                {/* Trigger div for infinite scroll */}
                {!showingSearch && isAllCategory && noProvidersSelected && (
                  <div ref={loaderRef} className="h-8 w-full" />
                )}

                {/* Optional loading spinner */}
                {loadMoreLoading && (
                  <div className="flex justify-center py-4">
                    <img src={Loader(domain)} alt="Loading..." className="h-6" />
                  </div>
                )}
            </>
          )
        }
      </div>
      {showPopup && (
        <Dialog
          fullScreen={false}
          open={showPopup}
          onClose={() => {
            setShowPopup(false);
          }}
          PaperProps={{
            style: {
              position: 'absolute',
              top: '5rem'
            }
          }}
        >
          <div className="dialog-bg bg-inputbox-color relative p-4">
            {/* Close Button */}
            <CloseIcon
              className="absolute top-3 right-3 text-white text-2xl font-semibold cursor-pointer"
              onClick={() => setShowPopup(false)}
            />
            <div className="text-white">
              <h2 className="text-lg font-semibold mb-2">⚠️ Real Money Game Only</h2>
              <p className="text-sm text-zinc-400 mb-4">
                This game does not support play chips.
                To play , you'll need to use real money
              </p>

              <div className="flex justify-center">
                <button
                  type="button"
                  className="p-2.5 w-[48%] text-sm text-white bg-error-color rounded-lg border border-error-color border-solid leading-[1.4rem]"
                  onClick={() => {
                    setShowPopup(false);
                    setPendingGameLink("");
                  }}
                >
                  Close
                </button>
                {/* <button
                  type="button"
                  className="p-2.5 w-[48%] text-sm text-white bg-border-color rounded-lg border border-border-color border-solid leading-[1.4rem]"
                  onClick={() => {
                    if (pendingGameLink) {
                      navigate(pendingGameLink);
                      setShowPopup(false);
                    }
                  }}
                >
                  Launch Game
                </button> */}
              </div>
            </div>
          </div>
        </Dialog>
      )}
      <Dialog
        fullScreen
        open={showProviderModal}
        onClose={() => setShowProviderModal(false)}
        PaperProps={{
          sx: {
            '@media (min-width: 768px)': {
              maxWidth: '26rem',
              margin: '0 auto',
              left: '50%',
              transform: 'translateX(-50%)',
              position: 'fixed',
            }
          }
        }}
      >
        <div className="bg-[#040d1a] h-full w-full p-4 pb-4 relative md:max-w-[26rem] md:mx-auto">
          {/* Row 1: Back button */}
          <div className="flex items-center gap-2 mr-[21.8rem]">
            {/* Icon with fixed background */}
            <div
              onClick={() => {
                setShowProviderModal(false);
                setProviderSearch("");
              }}
              className="bg-inputbox-color p-1 rounded"
            >
              <ArrowBackIcon
                className="text-border-color aspect-square w-[18px]"
                style={{ width: "20px", height: "20px" }}
              />
            </div>

            {/* Text stays outside the background */}
            <div className="text-white text-sm">Back</div>
          </div>

          {/* Row 2: Provider Search Full Width */}
          <div className="relative w-full mt-4 mb-4">
            <input
              type="text"
              value={providerSearch}
              onChange={(e) => setProviderSearch(e.target.value)}
              placeholder="Provider Search"
              className="w-full px-4 py-2 pr-10 rounded-lg bg-inputbox-color text-white border border-border-color"
            />
            {providerSearch ? (
              <button
                onClick={() => setProviderSearch("")}
                className="absolute right-3 top-2.5 text-white"
              >
                <CloseIcon fontSize="inherit" />
              </button>
            ) : (
              <img
                src={search}
                className="absolute right-3 top-2.5 w-4 h-4"
                alt="Search"
              />
            )}
          </div>

          {/* Row 3: Selections row */}
          <div className="flex justify-between items-center mb-4">
            <span className="text-white text-sm">{tempSelectedProviders.length} Selected</span>
            
            <div className="flex items-center gap-3">
              {/* Delete Icon */}
              {tempSelectedProviders.length > 0 && (
                <button
                  onClick={() => setTempSelectedProviders([])}
                  className="text-white rounded-full p-1"
                >
                  <img src={Delete} alt="Delete" className="w-4 h-4" />
                </button>
              )}

              {/* List/Grid Toggle */}
              <button onClick={() => setIsListView(!isListView)}>
                <img
                  src={isListView ? grid : list}
                  alt="Toggle View"
                  className="w-4 h-4"
                />
              </button>
            </div>
          </div>

          {/* Provider Grid or List */}
          {filteredProviders?.length === 0 ? (
            <div className="flex justify-center items-center text-zinc-400 text-sm min-h-[10rem]">
              No Providers Found
            </div>
          ) : isListView ? (
            <div className="flex flex-col gap-2 overflow-y-auto max-h-[calc(100vh-190px)] scrollbar-hide pb-[calc(env(safe-area-inset-bottom)+88px)]">
              {filteredProviders.map((prov: any, i) => {
                const isSelected = tempSelectedProviders.includes(prov.name);
                return (
                  <div
                    key={i}
                    className={`w-full px-4 py-2 pr-10 rounded-lg text-white border border-border-color
                      ${isSelected ? "bg-border-color" : "bg-inputbox-color"}`}
                    onClick={() => {
                      setTempSelectedProviders((prev) =>
                        prev.includes(prov.name)
                          ? prev.filter((p) => p !== prov.name)
                          : [...prev, prov.name]
                      );
                    }}
                  >
                    <span className="text-sm font-medium text-white truncate">{prov.subProvider}</span>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="grid grid-cols-4 gap-3 overflow-y-auto max-h-[calc(100vh-190px)] scrollbar-hide pb-[calc(env(safe-area-inset-bottom)+88px)]">
              {filteredProviders.map((prov: any, i) => {
                const isSelected = tempSelectedProviders.includes(prov.name);
                return (
                  <div
                    key={i}
                    className={`relative p-1 rounded-lg text-white border border-border-color cursor-pointer flex flex-col items-center justify-center transition-all
                      ${isSelected ? "bg-border-color" : "bg-inputbox-color"}`}
                    onClick={() => {
                      setTempSelectedProviders((prev) =>
                        prev.includes(prov.name)
                          ? prev.filter((p) => p !== prov.name)
                          : [...prev, prov.name]
                      );
                    }}
                  >
                    <img
                      loading="lazy"
                      src={prov.thumbnail}
                      alt={prov.name}
                      className="px-1 h-12 md:h-8 mb-1"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.onerror = null;
                        target.src = `${S3_IMG}/casino.svg`;
                      }}
                    />
                  </div>
                );
              })}
            </div>
          )}
          {/* Apply Button */}
          <div className="fixed bottom-0 left-0 right-0 md:left-1/2 md:-translate-x-1/2 md:max-w-[26rem] w-full flex justify-center px-4 pt-4 pb-[calc(env(safe-area-inset-bottom)+12px)] bg-[#040d1a] border-t border-white/10">
            <button
              onClick={handleApplyProviderFilters}
              disabled={tempSelectedProviders.length === 0}
              className={`px-10 py-3 rounded-lg font-semibold ${
                tempSelectedProviders.length === 0
                  ? "bg-gray-500 text-gray-300 cursor-not-allowed"
                  : "bg-white text-black"
              }`}
            >
              APPLY
            </button>
          </div>
        </div>
      </Dialog>
      {showScrollTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-[6rem] right-4 bg-border-color hover:bg-bg-border-color p-3 rounded-full shadow-md z-50 transition-all"
        >
          <img src={JumpToTop} alt="Top" className="w-4 h-4" />
        </button>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    casinoData: state.userDetails?.casinoData,
    activeWallet: state.userDetails?.activeWallet
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    setCasinoData: (data: any) => {
      dispatch(setCasinoData(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CasinoIframe);